module.exports = __webpack_public_path__ + "img/footer-empty-list-light.4e2bfeef.svg";